<template>
  <!-- Replaced by Instagram-style Bottom Navigation Bar -->
  <div class="d-none"></div>
</template>

<script>
export default {
  name: "CustomerPwaActionBar",
  props: {
    showInbox: {
      type: Boolean,
      default: true
    }
  }
}
</script>

